import { inject, Injectable } from '@angular/core'
import { PvtUsersService } from '../../../_services/users/users.service'
import { map } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private _usersService = inject(PvtUsersService)

  listUsers() {
    return this._usersService.listarTodosUsuarios().pipe(
      map(response => {
        response.sort((a, b) => a.nome.localeCompare(b.nome))
        return response
      })
    )
  }
}
